import { Suspense, lazy } from 'react';

import { Spin } from '@arco-design/web-react';

const LargeScreen = lazy(() => import('../system/global-view/large-screen').then((m) => ({ default: m.LargeScreen })));

export function ShareSystemLargeScreen() {
  return (
    <Suspense fallback={<Spin loading />}>
      <LargeScreen hiddenHeaderButtons containerStyle={{ height: '100vh' }} />
    </Suspense>
  );
}
